// import indexBy from "underscore/modules/indexBy";
// import {useState} from "react";
// import {useLoginFields} from "./Modal_2_8";


// export const Modal_2_1 = ({dismiss, onResult}) => {
//
//     const fields = useLoginFields();
//     let keyedFields = indexBy(fields, 'id');
//
//     const [errors, setErrors] = useState(false);
//
//     const handleScan = result => {
//         console.error(result);
//         if (result) {
//             //setQRData(result);
//             //play();
//             //handleSuccess(result);
//             alert(`代碼: ${result}`);
//             keyedFields.code.input.state.reset(result);
//             //onResult(result);
//         }
//     }
//     }
// }


import {Logout} from "../store/Common_Store";

export const handleFetchCommonErrors = (router, errorObj) => {
    if (!errorObj) {
        console.warn(['errorObj', errorObj]);
        return false;
    }
    if (errorObj.code === 2) {
        navAwayToPg_A_1(router);
        return true;
    }

    return false;
}

export const handleCommonFetchErrors = (router, errorObj) => {
    if (!errorObj) {
        console.warn(['errorObj', errorObj]);
        return false;
    }
    if (errorObj.code === 2) {
        navAwayToPg_A_1(router);
        return true;
    }

    return false;
}

export const promptBrowserToLogin = () => {
    navAwayToPg_A_1();
}

export const handleExecutor = async (executionQueue: string[]) => {
    if (executionQueue === null) {
        return;
    }
    for (const exec of executionQueue) {
        if (exec === "notloggin") {
            await Logout(false);
        }
    }
}

export const navAwayToPg_A_1 = (router: any = null) => {
    if (window) {
        ///isBrowser
        let pathName = window.location.pathname;
        let currentUrl = window.location.toString();

        if (pathName !== '/A_1') {
            window.location.replace('/A_1?redirTo=' + encodeURIComponent(currentUrl));
        } else {
            window.location.replace('/A_1');
        }
        //router.push("/A_1", "forward", "push");
    }
}

export const navAwayToPg_1_1 = (router: any) => {
    router.push("/tabs/1_1", "forward", "push");
}

export const navAwayToPg_1_2 = (router: any) => {
    router.push("/tabs/1_2", "forward", "push");
}

export const navAwayToRoot = (router: any) => {
    router.push(`/`, "forward", "push");
}

export const navAwayToPg_0_22 = (router: any) => {
    router.push("/tabs/0_22", "forward", "push");
}

export const navAwayToPg_0_24 = (router: any) => {
    router.push("/tabs/0_24", "forward", "push");
}

export const navAwayToPg_0_18 = (router: any) => {
    router.push("/tabs/0_18", "forward", "push");
}

export const navAwayToPg_0_19 = (router: any) => {
    router.push("/tabs/0_19", "forward", "push");
}

export const navAwayToPg_5_1 = (router: any) => {
    router.push("/tabs/5_1", "forward", "push");
}

export const navAwayToPg_5_5 = (router: any) => {
    router.push("/tabs/5_5", "forward", "push");
}

export const navAwayToPg_5_7 = (router: any) => {
    router.push("/tabs/5_7", "forward", "push");
}

export const navAwayToPg_B_1 = (router: any) => {
    router.push("/tabs/B_1", "forward", "push");
}

export const navAwayToPg_C_1 = (router: any) => {
    router.push("/tabs/C_1", "forward", "push");
}

export const navAwayToPg_2_13 = (router: any) => {
    router.push("/tabs/2_13", "forward", "push");
}

export const navAwayToPg_2_1 = (router: any) => {
    router.push("/tabs/2_1", "forward", "push");
}
export const navAwayToPg_6_1 = (router: any) => {
    router.push("/tabs/6_1", "forward", "push");
}
export const navAwayToPg_6_2 = (router: any) => {
    router.push("/tabs/6_2", "forward", "push");
}
export const navAwayToPg_6_3 = (router: any, 撥放清單Id) => {
    router.push(`/tabs/6_3/${撥放清單Id}`, "forward", "push");
}

export const navAwayToPg_6_4 = (router: any, 撥放清單Id) => {
    router.push(`/tabs/6_4/${撥放清單Id}`, "forward", "push");
}
